import EventForm from "./EventForm";
import useEventActions from "../useEventActions";
import { useState } from "react";

export default function CreateEventCalendar({ onNext }) {
  const { createEvent } = useEventActions();
  const [isLoading, setIsLoading] = useState(false);
  const initialFormValues = {
    start_date: "",
    end_date: "",
    name: "",
    start_time: "",
    description: "",
    address: "",
    duration: "",
    reminder_count: "",
    attendees: "",
  };
  const handleFormSubmit = async (formikValues, resetForm) => {
    const reqBody = {
      ...formikValues,
    };

    setIsLoading(true);
    try {
      await createEvent(reqBody);
      // Only reset form on successful creation
      resetForm();
      if (onNext) {
        onNext();
      }
    } catch (error) {
      console.error("Failed to create event:", error);
      // Don't reset form on error - preserve user input
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <EventForm
        onNext={handleFormSubmit}
        btnText={"Create new event"}
        initialFormValues={initialFormValues}
        isLoading={isLoading}
      />
    </>
  );
}
